export const checkCountAndStatusWasSet = (status, count, statusIsWithoutCount) => {
  if (statusIsWithoutCount) return true;
  return !!status && !!count;
};